import { render, staticRenderFns } from "./HRPolicyHandbook.vue?vue&type=template&id=7e587bb4"
import script from "./HRPolicyHandbook.vue?vue&type=script&lang=js"
export * from "./HRPolicyHandbook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports